import { Box, BoxProps } from "@mui/material";
import React from "react";

// Centres page content with a comfortable reading width and responsive
// horizontal padding, so screens don't stretch edge-to-edge on desktop.
export function PageContainer({ children, sx, ...rest }: BoxProps) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 720,
        mx: "auto",
        px: { xs: 2.5, sm: 3 },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
